import { render, staticRenderFns } from "./RightFunPop.vue?vue&type=template&id=b8489f3c&scoped=true"
import script from "./RightFunPop.vue?vue&type=script&lang=js"
export * from "./RightFunPop.vue?vue&type=script&lang=js"
import style0 from "./RightFunPop.vue?vue&type=style&index=0&id=b8489f3c&prod&lang=scss&scoped=true"
import style1 from "./RightFunPop.vue?vue&type=style&index=1&id=b8489f3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8489f3c",
  null
  
)

export default component.exports